import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/candidate',
    authDomain: 'login.seek.com',
    clientDomain: 'hk.jobsdb.com',
    clientId: 's4xKhkaQlScs656DuHcvEJnbDU3W5Mkn',
    environment: 'prod',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    brand: Brand.JOBSDB,
    contactUs: {
        en: 'https://hk.jobsdb.com/en-hk/pages/regional-coverage/',
    },
    siteName: siteNames.candidate.jobsdb.hk,
    zone: getZoneFromSite(siteNames.candidate.jobsdb.hk),
    product: Product.SEEK,
};
//# sourceMappingURL=hk_jobsdb_com.js.map